var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61342 8.47545C1.52262 8.33169 1.47723 8.25981 1.45182 8.14895C1.43273 8.06567 1.43273 7.93434 1.45182 7.85106C1.47723 7.74019 1.52262 7.66831 1.61341 7.52455C2.36369 6.33656 4.59693 3.33334 8.00027 3.33334C11.4036 3.33334 13.6369 6.33656 14.3871 7.52455C14.4779 7.66831 14.5233 7.74019 14.5487 7.85106C14.5678 7.93434 14.5678 8.06567 14.5487 8.14895C14.5233 8.25981 14.4779 8.33169 14.3871 8.47545C13.6369 9.66344 11.4036 12.6667 8.00027 12.6667C4.59693 12.6667 2.36369 9.66344 1.61342 8.47545Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00027 10C9.10484 10 10.0003 9.10457 10.0003 8C10.0003 6.89543 9.10484 6 8.00027 6C6.8957 6 6.00027 6.89543 6.00027 8C6.00027 9.10457 6.8957 10 8.00027 10Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.63ab2dc80a9e9c5247da38c9b0184666.svg";
export { ForwardRef as ReactComponent };